module.exports = __webpack_public_path__ + "static/media/rain.db5959bc.svg";